import React from "react";
import { Badge } from "react-bootstrap";
import { Type } from "../actions/types";
import { useNavigate } from "react-router-dom";

interface Props {
  types: Type[];
  excludeTypes?: string[];
}

const ProductTagsTypes = (props: Props) => {
  const { types, excludeTypes = [] } = props;
  const navigate = useNavigate();

  const filteredTypes = types.filter(
    (type) => !excludeTypes.includes(type.name)
  );

  const handleClick = (e: React.MouseEvent, id: number) => {
    e.preventDefault();
    e.stopPropagation();
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/product-type/${id}`);
  };

  return (
    <>
      {filteredTypes.map((type, index: number) => (
        <Badge 
          bg="dark" 
          key={index} 
          className="mb-2 me-1"
          style={{ cursor: "pointer" }}
          onClick={(e) => handleClick(e, type.id)}
        >
          {type.name}
        </Badge>
      ))}
    </>
  );
};

export default ProductTagsTypes;
